import { filter } from 'rxjs';

import type { OperatorFunction } from 'rxjs';

/**
 * Filters all *Falsy* values from the stream
 */
export function filterFalsy<T>(): OperatorFunction<
  T,
  Exclude<T, '' | 0 | false | null | undefined>
> {
  return filter(
    (value): value is Exclude<T, '' | 0 | false | null | undefined> => !!value,
  );
}
